import { Route, Routes } from 'react-router-dom';
import { AddressVerifictionLayout } from './AddressVerifictionLayout';
import AddressReconfirm from './reConfirm';
import AddressVerificationLink from './addressVerification';
import AddressSuccess from './success';
import { UpdateRedemAddress } from './addressUpdate';
import { SupportForm } from '../../customerCard/components/support/supportForms/SupportForm';
import NotFound from '../../customerCard/components/userNotFound';

/**
 * AddressVerifictionRoute
 * Defines the routing structure for address verification, update, reconfirmation, and support pages.
 */
const AddressVerifictionRoute = () => {

    return <Routes>
        <Route element={<AddressVerifictionLayout />}>
            <Route
                path='verify'
                element={<AddressVerificationLink />}
            />
            <Route
                path='re-confirm'
                element={<AddressReconfirm />}
            />

            <Route
                path='update'
                element={<UpdateRedemAddress />}
            />
            <Route
                path='notFound'
                element={<NotFound />}
            />
            <Route
                path='success'
                element={<AddressSuccess />}
            />
            <Route
                path='support'
                element={<SupportForm />}
            />
        </Route>
    </Routes>

};

export default AddressVerifictionRoute;
